import { css } from '@emotion/core';
import { variables, media, tokens, getCssVariableValue } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var font = variables.font;
var colors = tokens.colors;
export var lineGraphHeight = 290;
export var uvRoundelColour = () => getCssVariableValue(colors.interactive.base.default);
export var suburbStatsFull = {
  name: "zsrvks",
  styles: "margin-bottom:50px;max-width:1020px;"
};
export var tabbedPanel = {
  name: "i9gxme",
  styles: "flex-grow:1;"
};
export var tabWrapper = /*#__PURE__*/css("display:flex;text-align:left;margin-bottom:16px;font-size:", font.smallFontSize, ";.is-active{color:black !important;font-weight:", font.headingFontWeight, ";}.unimproved,.median{margin-right:30px;&:not(.is-active){color:", colors.neutral.medium.default, " !important;font-weight:", font.headingFontWeight, ";}}");
export var panel = /*#__PURE__*/css("position:relative;padding:24px;border:1px solid ", colors.neutral.trim.default, ";border-radius:10px;overflow:hidden;");
export var chartContainer = /*#__PURE__*/css("display:flex;flex-direction:column;width:100%;justify-content:space-between;gap:32px;", media('>=tablet'), "{gap:72px;}");
export var title = {
  name: "1q7njkh",
  styles: "margin-top:10px;"
};
export var sectionContainer = {
  name: "1vsovhk",
  styles: "display:flex;flex-direction:column;margin-top:16px;overflow:hidden;"
};
export var ctaCard = {
  name: "1yuhvjn",
  styles: "margin-top:16px;"
};
export var legend = {
  name: "1qm1lh",
  styles: "margin-bottom:16px;"
};
export var legendLabel = /*#__PURE__*/css(designTokenFonts.mini, " color:", colors.neutral.medium.default, ";margin-bottom:4px;");
export var legendValue = /*#__PURE__*/css("display:flex;align-items:center;color:", colors.neutral.heavy.default, ";", designTokenFonts.subheading, ";gap:8px;");
export var roundel = _ref => {
  var colour = _ref.colour;
  return /*#__PURE__*/css("position:relative;top:-1px;height:16px;width:16px;border-radius:8px;border:4px solid ", colour, ";background-color:", tokens.colors.neutral.surface.default, ";");
};